// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4216":"2e583f4582bcb0b7","6397":"337232d562e8aff8","9163":"6c99a66d4cf61204"}[chunkId] + ".js";
};